import JwtDecode from 'jwt-decode'
import WelcomebookManager from '../managers/welcomeBookManager'

const state = {
  email: '',
  authenticated: false,
  token: {
    access: null,
    refresh: null,
    expires: null
  }
}

const actions = {
  async singIn(context, token) {
    context.commit('setAuthToken', token)
  },
  async refreshToken(context) {
    const tokens = await WelcomebookManager.refreshToken(context)
    return tokens
  }
}

const mutations = {
  setAuthToken(state, data) {
    if (data.access_token) {
      const decoded = JwtDecode(data.access_token)
      const date = new Date(decoded.exp * 1000)
      state.token.access = data.access_token
      state.token.expires = date
      state.authenticated = true
      state.email = decoded.email
    }
    if (data.refresh_token) {
      const decoded = JwtDecode(data.refresh_token)
      const date = new Date(decoded.exp * 1000)
      state.token.refresh = data.refresh_token
      state.token.outdates = date
    } else {
      state.token.outdates = new Date(0)
    }
  }
}

const getters = {
  isAuth: state => state.authenticated,
  token: state => state.token.access
}

export default {
  state,
  actions,
  mutations,
  getters
}
